import { ModelTypes } from "types";

export const getLabelTextForModelType = (type: ModelTypes) => {
  switch (type) {
    case ModelTypes.CAPTION_IMAGES:
    case ModelTypes.CAPTION_OBJECTS:
      return "captions";
    case ModelTypes.IMAGE_TAGGING:
    case ModelTypes.OBJECT_TAGGING:
      return "tags";
    default:
      return "labels";
  }
};
